export const pagesToShowBanner = [
    "digitalsuite_websiteanalysis",
    "digitalsuite_website",
    "digitalsuite_website_audience",
    "digitalsuite_website_referrals",
    "digitalsuite_website_publisher_overview_frame",
];
